(function() {
    'use strict';

    angular.module('allegro').controller('AllegroOfferCreateController', AllegroOfferCreateController);

    AllegroOfferCreateController.$inject = [
        '$scope',
        '$state',
        '$q',
        'allegroOffersDataSrvc',
        'allegroOfferMessagesConst',
        'productDataSrvc',
        'productSrvc',
        'productOptionDataSrvc',
        'allegroAccountDataSrvc',
        'allegroSrvc',
        'notificationSrvc',
        'errorNotificationSrvc'
    ];

    function AllegroOfferCreateController(
        $scope, $state, $q, allegroOffersDataSrvc, allegroOfferMessagesConst, productDataSrvc, productSrvc,
        productOptionDataSrvc, allegroAccountDataSrvc, allegroSrvc, notificationSrvc, errorNotificationSrvc
    ) {
        var self = this;

        self.loading = false;
        self.saving = false;

        self.serverErrors = {};
        self.modalData = {
            accountId: $state.params.pk,
            categoryNameForSearch: null,
            category: {},
            breadcrumbCategories: []
        };
        self.productOpts = [];
        self.productQuantityOpts = [];
        self.productGroupOptionsOpts = [];
        self.shoppingRateOpts = [];
        self.impliedWarrantyOpts = [];
        self.returnPolicyOpts = [];
        self.publicationDurationOpts = [];
        self.deliveryHandlingTimeOpts = [];

        self.selectedProductOptions = {};

        self.fieldRef = {
            weight: null
        }

        self.fieldRefValues = {
            weight: 0
        };

        self.account = {};
        self.offerData = {
            account: $state.params.pk,
            product: null,
            quantity: null,
            chosen_options: [],
            title: '',
            description: '',
            available_number: null,
            price: null,
            publication_duration: 'WSL',
            republish: false,
            delivery_handling_time: null,
            data: {
                category: null,
                parameters: [],
                shoppingRate: null,
                impliedWarranty: null,
                returnPolicy: null
            },
        };

        self.selectedProduct = null;
        self.selectedQuantity = null;

        self.onInitView = onInitView;
        self.getAccount = getAccount;
        self.getProducts = getProducts;
        self.getProductQuantities = getProductQuantities;
        self.getProductGroupOptions = getProductGroupOptions;
        self.getOfferPricing = getOfferPricing;
        self.getOfferWeight = getOfferWeight;
        self.getOfferDescription = getOfferDescription;
        self.onProductChange = onProductChange;
        self.onProductSearch = onProductSearch;
        self.updateOfferTitle = updateOfferTitle;
        self.onQuantityChange = onQuantityChange;
        self.onProductOptionChange = onProductOptionChange;
        self.isMultipleGroupOption = productSrvc.isMultipleGroupOption;
        self.isPossibleDisplayProductGroupOption = isPossibleDisplayProductGroupOption;
        self.isProductGroupOptionFieldsFilled = isProductGroupOptionFieldsFilled;
        self.getChosenOptionPks = getChosenOptionPks;
        self.openCategorySelectModal = openCategorySelectModal;
        self.getCategoryParameters = getCategoryParameters;
        self.getShoppingRates = getShoppingRates;
        self.getImpliedWarranties = getImpliedWarranties;
        self.getReturnPolicies = getReturnPolicies;
        self.getPublicationDurations = getPublicationDurations;
        self.getDeliveryHandlingTimes = getDeliveryHandlingTimes;
        self.initialParametersObjModel = initialParametersObjModel;
        self.isBasicFieldsFilled = isBasicFieldsFilled;
        self.showAllegroFields = showAllegroFields;
        self.createOffer = createOffer;
        self.cleanErrors = cleanErrors;

        activate();
        function activate() {
            onInitView();
        }

        function onInitView(){
            self.loading = true;

            getAccount($state.params.pk);
            $q.all([
                getProducts(),
                getShoppingRates($state.params.pk),
                getImpliedWarranties($state.params.pk),
                getReturnPolicies($state.params.pk),
                getPublicationDurations($state.params.pk),
                getDeliveryHandlingTimes($state.params.pk)
            ])
            .then(function (results) {
            })
            .catch(function (error) {
                console.error("Error loading data:", error);
            })
            .finally(function () {
                self.loading = false;
            });
        }

        function getAccount(accountId) {
            self.loading = true;

            return allegroAccountDataSrvc.get({pk: accountId})
                .$promise
                .then(function (response) {
                    self.account = response;
                    return response;
                })
                .catch(function(response) {
                    if (response.status === 404) {
                        notificationSrvc.notification("error", response.data.detail);
                        $state.go('layout.allegro-accounts.list');
                    }
                })
                .finally(function (response) {});
        }

        function getProducts() {
            return productDataSrvc.allegroOptionsList().$promise.then(
                function (response) {
                    self.productOpts = response.results;
                    return response;
                }
            )
        }

        function getProductQuantities(productId){
            return productDataSrvc.getQuantities({pk: productId}).$promise.then(
                function (response) {
                    self.productQuantityOpts = response;
                    return response;
                }
            )
        }

        function getProductGroupOptions(productId){
            return productDataSrvc.getProductGroupOptions({pk: productId}).$promise.then(
                function (response) {
                    self.productGroupOptionsOpts = response;
                    return response;
                }
            )
        }

        function getOfferPricing(){
            return productDataSrvc.getProductPricing({
                pk: self.selectedProduct.pk,
                quantity_pk: self.selectedQuantity.pk,
                option_pk: self.getChosenOptionPks()
            }).$promise.then(
                function (response) {
                    self.offerData.price = response.price;
                    return response;
                }
            )
        }

        function getOfferWeight(){
            return productDataSrvc.getProductWeight({
                pk: self.selectedProduct.pk,
                quantity_pk: self.selectedQuantity.pk,
                option_pk: self.getChosenOptionPks()
            }).$promise.then(
                function (response) {
                    self.fieldRefValues.weight = response.weight;

                    if (self.fieldRef.weight) {
                        var parameterId = self.fieldRef.weight.id;
                        self.fieldRef.weight['objectModel'][parameterId] = self.fieldRefValues.weight;
                    }
                    return response;
                }
            )
        }

        function getOfferDescription(){
            return productDataSrvc.getProductDescriptionForOffer({
                pk: self.selectedProduct.pk,
                quantity_pk: self.selectedQuantity.pk,
                option_pk: self.getChosenOptionPks()
            }).$promise.then(
                function (response) {
                    self.offerData.description = response.description;
                    return response;
                }
            )
        }

        function getShoppingRates(accountId){
            return allegroAccountDataSrvc.getShoppingRates({pk: accountId}).$promise.then(
                function (response) {
                    self.shoppingRateOpts = response.shippingRates;
                    return response;
                }
            )
        }

        function getImpliedWarranties(accountId){
            return allegroAccountDataSrvc.getImpliedWarranties({pk: accountId}).$promise.then(
                function (response) {
                    self.impliedWarrantyOpts = response.impliedWarranties;
                    return response;
                }
            )
        }

        function getReturnPolicies(accountId){
            return allegroAccountDataSrvc.getReturnPolicies({pk: accountId}).$promise.then(
                function (response) {
                    self.returnPolicyOpts = response.returnPolicies;
                    return response;
                }
            )
        }

        function getPublicationDurations(accountId){
            return allegroAccountDataSrvc.getPublicationDurations({pk: accountId}).$promise.then(
                function (response) {
                    self.publicationDurationOpts = response;
                    return response;
                }
            )
        }

        function getDeliveryHandlingTimes(accountId){
            return allegroAccountDataSrvc.getDeliveryHandlingTimes({pk: accountId}).$promise.then(
                function (response) {
                    self.deliveryHandlingTimeOpts = response;
                    return response;
                }
            )
        }

        function onProductChange(product) {
            self.selectedProduct = product;
            self.offerData.quantity = null;
            self.offerData.data.category = null;
            self.offerData.data.parameters = [];
            self.modalData.categoryNameForSearch = null;
            self.modalData.category = {};
            self.modalData.breadcrumbCategories = [];

            if (product.category_names.length > 0){
                self.modalData.categoryNameForSearch = product.category_names[0];
            }

            self.getProductQuantities(product.pk);
            self.getProductGroupOptions(product.pk);
            self.updateOfferTitle();
        }

        function onProductSearch(params) {
            if (!params) {
                params = {};
            }
            return productDataSrvc.allegroOptionsList(params).$promise;
        }

        function onQuantityChange(quantity){
            self.selectedQuantity = quantity;
            self.getOfferPricing();
            self.getOfferWeight();
            self.updateOfferTitle();
        }

        function onProductOptionChange(option){
            if (self.isBasicFieldsFilled()) {
                self.getOfferPricing();
                self.getOfferWeight();
                self.getOfferDescription();
            }
        }

        function updateOfferTitle(){
            self.offerData.title = '';

            if(self.selectedProduct !== null){
                self.offerData.title = self.selectedProduct.name;
            }

            if (self.selectedQuantity !== null) {
                self.offerData.title += ', ' + self.selectedQuantity.display_quantity + ' szt.'
            }
        }

        function onCategorySelect(data){
            self.modalData = data;
            self.offerData.data.category = self.modalData.category.id;
            self.getCategoryParameters($state.params.pk, self.offerData.data.category)
        }

        function getCategoryParameters(accountPk, categoryId) {
            self.offerData.data.parameters = [];

            return allegroAccountDataSrvc.getCategoryParameters({
                pk: accountPk,
                category_id: categoryId
            }).$promise.then(function (response) {
                self.offerData.data.parameters = response.parameters;
                self.initialParametersObjModel(self.offerData.data.parameters);
                return response;
            })
        }

        function openCategorySelectModal(data) {
            allegroSrvc.categorySelectModal(data, onCategorySelect, angular.noop)
        }

        function getChosenOptionPks(){
            var pks = [];

            for (var key in self.selectedProductOptions) {
                if (angular.isArray(self.selectedProductOptions[key])) {
                    self.selectedProductOptions[key].map(function(pk) {
                        pks.push(pk);
                    });
                } else {
                    pks.push(self.selectedProductOptions[key]);
                }
            }
            return pks
        }

        function createOffer() {
            if (self.saving) {
                return;
            }

            self.saving = true;
            self.offerData.chosen_options = self.getChosenOptionPks();

            allegroOffersDataSrvc.create(self.offerData)
                .$promise.then(function(response) {
                    notificationSrvc.notification("success", allegroOfferMessagesConst.add);
                    if (Object.keys(response.external_errors).length === 0) {
                        $state.go('layout.allegro-accounts.detail.offers', { pk: $state.params.pk });
                    } else {
                        errorNotificationSrvc.displayErrors(response.external_errors);
                        $state.go('layout.allegro-offers.update', { pk: response.pk });
                    }
                }).catch(function(response){
                    if (response.status === 400){
                        self.serverErrors = response.data;
                        errorNotificationSrvc.displayErrors(response.data);
                    } else {
                        notificationSrvc.notification("error", response.statusText);
                    }
                }).finally(function () {
                    self.saving = false;
                });
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }

        function initialParametersObjModel(parameters){
            parameters.forEach(function(parameter, index) {
                parameter['objectModel'] = {};
                if(parameter.type === 'dictionary' && parameter.restrictions.multipleChoices){
                    parameter['objectModel'][parameter.id] = [];
                } else {
                    parameter['objectModel'][parameter.id] = "";
                }

                if (self.fieldRefValues.weight > 0 && parameter.name.toLowerCase().includes('waga')){
                    parameter['objectModel'][parameter.id] = self.fieldRefValues.weight;
                    self.fieldRef.weight = parameter;
                }
            });
        }

        function isBasicFieldsFilled(){
            return self.offerData.product !== null && self.offerData.quantity !== null &&
                self.isProductGroupOptionFieldsFilled()
        }

        function showAllegroFields(){
            return self.offerData.data.parameters.length > 0
        }

        function isPossibleDisplayProductGroupOption(opt){
            var opts = opt.options.filter(function(item){
                return item.enter_values_possible === true;
            });
            return opts.length > 0;
        }

        function isProductGroupOptionFieldsFilled(){
            var groupOptionIds = [];
            for (var i = 0; i < self.productGroupOptionsOpts.length; i++) {
                var opt = self.productGroupOptionsOpts[i];
                if (!isPossibleDisplayProductGroupOption(opt)){
                    groupOptionIds.push(opt.group_option.pk)
                }
            }
            return groupOptionIds.length === Object.keys(self.selectedProductOptions).length;
        }
    }
})();
